var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useContext, useEffect, useRef, useState, } from "react";
import { ActivityIndicator, Animated, Easing, Modal, StyleSheet, TextInput, TouchableOpacity, TouchableWithoutFeedback, View, } from "react-native";
import { StyledText } from "./Text";
import { ThemeContext } from "../Theme";
import { isScreenSmall } from "../Helpers";
export var LorecraftPopup = function (_a) {
    var visible = _a.visible, onClose = _a.onClose, onSubmit = _a.onSubmit, _b = _a.loading, loading = _b === void 0 ? false : _b, _c = _a.description, description = _c === void 0 ? "We'll email you when the Kickstarter is open!" : _c, _d = _a.submitLabel, submitLabel = _d === void 0 ? "Join Waitlist" : _d, _e = _a.placeholder, placeholder = _e === void 0 ? "you@email.com" : _e, _f = _a.defaultEmail, defaultEmail = _f === void 0 ? "" : _f, _g = _a.accentColor, accentColor = _g === void 0 ? "#5B80A0" : _g;
    var theme = useContext(ThemeContext);
    var smallScreen = isScreenSmall();
    var _h = useState(defaultEmail), email = _h[0], setEmail = _h[1];
    var _j = useState(null), error = _j[0], setError = _j[1];
    var _k = useState(visible), shouldRender = _k[0], setShouldRender = _k[1];
    var overlayOpacity = useRef(new Animated.Value(0)).current;
    var cardScale = useRef(new Animated.Value(0.92)).current;
    var cardTranslateY = useRef(new Animated.Value(40)).current;
    var cardOpacity = useRef(new Animated.Value(0)).current;
    useEffect(function () {
        if (visible) {
            setShouldRender(true);
            setEmail(defaultEmail);
            setError(null);
            overlayOpacity.stopAnimation();
            cardScale.stopAnimation();
            cardTranslateY.stopAnimation();
            cardOpacity.stopAnimation();
            overlayOpacity.setValue(0);
            cardScale.setValue(0.92);
            cardTranslateY.setValue(40);
            cardOpacity.setValue(0);
            Animated.parallel([
                Animated.timing(overlayOpacity, {
                    toValue: 1,
                    duration: 260,
                    easing: Easing.out(Easing.cubic),
                    useNativeDriver: true,
                }),
                Animated.spring(cardScale, {
                    toValue: 1,
                    useNativeDriver: true,
                    friction: 6,
                    tension: 75,
                }),
                Animated.spring(cardTranslateY, {
                    toValue: 0,
                    useNativeDriver: true,
                    friction: 6,
                    tension: 120,
                }),
                Animated.timing(cardOpacity, {
                    toValue: 1,
                    duration: 280,
                    easing: Easing.out(Easing.cubic),
                    useNativeDriver: true,
                }),
            ]).start();
        }
        else if (shouldRender) {
            Animated.parallel([
                Animated.timing(overlayOpacity, {
                    toValue: 0,
                    duration: 180,
                    easing: Easing.in(Easing.cubic),
                    useNativeDriver: true,
                }),
                Animated.timing(cardScale, {
                    toValue: 0.92,
                    duration: 180,
                    easing: Easing.inOut(Easing.ease),
                    useNativeDriver: true,
                }),
                Animated.timing(cardTranslateY, {
                    toValue: 40,
                    duration: 180,
                    easing: Easing.inOut(Easing.ease),
                    useNativeDriver: true,
                }),
                Animated.timing(cardOpacity, {
                    toValue: 0,
                    duration: 140,
                    easing: Easing.in(Easing.linear),
                    useNativeDriver: true,
                }),
            ]).start(function (_a) {
                var finished = _a.finished;
                if (finished && !visible) {
                    setShouldRender(false);
                    overlayOpacity.setValue(0);
                    cardOpacity.setValue(0);
                    cardTranslateY.setValue(40);
                    cardScale.setValue(0.92);
                }
            });
        }
    }, [visible, shouldRender, defaultEmail, overlayOpacity, cardScale, cardTranslateY, cardOpacity]);
    var handleOverlayPress = function () {
        if (onClose)
            onClose();
    };
    var handleSubmit = function () {
        var trimmed = email.trim();
        if (!trimmed) {
            setError("Email required");
            return;
        }
        var emailRegex = /[^@\s]+@[^@\s]+\.[^@\s]+/;
        if (!emailRegex.test(trimmed)) {
            setError("Enter a valid email");
            return;
        }
        setError(null);
        onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit(trimmed);
    };
    return (_jsx(Modal, __assign({ transparent: true, visible: shouldRender, animationType: "none", onRequestClose: onClose }, { children: _jsxs(View, __assign({ style: styles.modalRoot }, { children: [_jsx(TouchableWithoutFeedback, __assign({ onPress: handleOverlayPress }, { children: _jsx(Animated.View, { style: [styles.backdrop, { opacity: overlayOpacity }] }) })), _jsxs(Animated.View, __assign({ style: [
                        styles.card,
                        {
                            opacity: cardOpacity,
                            transform: [{ scale: cardScale }, { translateY: cardTranslateY }],
                            borderColor: accentColor,
                            shadowColor: accentColor,
                            width: smallScreen ? "90%" : 460,
                        },
                    ] }, { children: [onClose && (_jsx(TouchableOpacity, __assign({ accessibilityLabel: "Close waitlist popup", onPress: onClose, style: styles.closeButton }, { children: _jsx(StyledText, __assign({ type: "button" }, { children: "x" })) }))), _jsx(StyledText, __assign({ type: "caption", style: {
                                marginTop: 12,
                                textAlign: "left",
                                color: theme.text.color,
                                textShadowColor: "#0A1F33",
                                textShadowOffset: { width: 1, height: 1 },
                                textShadowRadius: 6,
                            } }, { children: description })), _jsx(TextInput, { autoCapitalize: "none", autoComplete: "email", keyboardType: "email-address", placeholder: placeholder, placeholderTextColor: "rgba(255,255,255,0.5)", value: email, onChangeText: setEmail, style: [
                                styles.input,
                                {
                                    borderColor: accentColor,
                                    color: theme.text.color,
                                },
                            ] }), error && (_jsx(StyledText, __assign({ type: "subscript", style: styles.error }, { children: error }))), _jsx(TouchableOpacity, __assign({ onPress: handleSubmit, activeOpacity: 0.85, style: [
                                styles.button,
                                { backgroundColor: accentColor },
                                loading && styles.buttonDisabled,
                            ], disabled: loading }, { children: loading ? (_jsx(ActivityIndicator, { color: "#071221" })) : (_jsx(StyledText, __assign({ type: "button", style: styles.buttonLabel }, { children: submitLabel }))) }))] }))] })) })));
};
var styles = StyleSheet.create({
    modalRoot: {
        flex: 1,
        justifyContent: "center",
        alignItems: "center",
    },
    backdrop: __assign(__assign({}, StyleSheet.absoluteFillObject), { backgroundColor: "rgba(1, 5, 12, 0.85)" }),
    card: {
        backgroundColor: "rgba(5, 14, 32, 0.95)",
        borderRadius: 28,
        borderWidth: 2,
        paddingVertical: 32,
        paddingHorizontal: 28,
        shadowOpacity: 0.4,
        shadowOffset: { width: 0, height: 20 },
        shadowRadius: 30,
        elevation: 12,
    },
    closeButton: {
        position: "absolute",
        top: 16,
        right: 16,
        padding: 8,
    },
    input: {
        marginTop: 16,
        borderWidth: 1,
        borderRadius: 999,
        paddingVertical: 12,
        paddingHorizontal: 24,
        fontSize: 16,
        backgroundColor: "rgba(2, 8, 18, 0.8)",
    },
    error: {
        color: "#EF4444",
        marginTop: 6,
    },
    button: {
        marginTop: 20,
        borderRadius: 999,
        paddingVertical: 14,
        alignItems: "center",
    },
    buttonDisabled: {
        opacity: 0.7,
    },
    buttonLabel: {
        textTransform: "uppercase",
        letterSpacing: 1,
    },
});
